import { createAction } from 'redux-actions';

export const getPendingSmartwayRequest = createAction('GET_PENDING_SMARTWAY_REQUEST');
export const getPendingSmartwaySuccess = createAction('GET_PENDING_SMARTWAY_SUCCESS');
export const getPendingSmartwayFail = createAction('GET_PENDING_SMARTWAY_FAIL');
